(function() {
  'use strict';

  var popupTimeout = null;
  var popupCloseTimeout = null;

  function cleanupPreviousPopup() {
    if (popupTimeout) {
      clearTimeout(popupTimeout);
      popupTimeout = null;
    }
    if (popupCloseTimeout) {
      clearTimeout(popupCloseTimeout);
      popupCloseTimeout = null;
    }
    var container = document.getElementById('react-addtocart-popup');
    if (container) {
      container.innerHTML = '';
    }
  }

  function showPopupFallback() {
    if (typeof showPopup === 'function') {
      showPopup('.product-popup');
    } else if (typeof jQuery !== 'undefined' && jQuery.fn.addClass) {
      jQuery('.product-popup').addClass('active');
    }
  }

  function hidePopupFallback() {
    if (typeof hidePopup === 'function') {
      hidePopup('.product-popup');
    } else if (typeof jQuery !== 'undefined' && jQuery.fn.removeClass) {
      jQuery('.product-popup').removeClass('active');
    }
  }

  window.closeAddToCartPopup = function() {
    var popupContent = document.querySelector('.product-popup .react-addtocart-popup-content');

    if (popupContent) {
      popupContent.style.transition = 'opacity 0.3s ease-out';
      popupContent.style.opacity = '0';
    }

    popupCloseTimeout = setTimeout(function() {
      hidePopupFallback();
      var container = document.getElementById('react-addtocart-popup');
      if (container) {
        container.innerHTML = '';
      }
      if (popupTimeout) {
        clearTimeout(popupTimeout);
        popupTimeout = null;
      }
      popupCloseTimeout = null;
    }, 300);
  };

  window.showAddToCartReactPopup = function() {
    cleanupPreviousPopup();

    var container = document.getElementById('react-addtocart-popup');
    if (!container) {
      showPopupFallback();
      return;
    }

    container.innerHTML =
      '<div class="react-addtocart-popup-content" style="position:relative;width:100%;max-width:500px;background:#fff;border-radius:24px;padding:64px 48px;text-align:center;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);animation:fadeInZoom 0.5s ease-out;z-index:9999;">' +
        '<div style="padding:16px;background:rgba(33,37,41,0.1);border-radius:50%;display:inline-block;margin-bottom:24px;">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>' +
            '<polyline points="22 4 12 14.01 9 11.01"></polyline>' +
          '</svg>' +
        '</div>' +
        '<h2 style="font-family:D-DIN,sans-serif;font-size:20px;font-weight:bold;text-transform:uppercase;color:#212529;margin:0;margin-top:8px;letter-spacing:0.1em;line-height:1.5;">PRODUCTO AGREGADO AL CARRITO</h2>' +
      '</div>';

    showPopupFallback();

    popupTimeout = setTimeout(function() {
      window.closeAddToCartPopup();
    }, 4500);
  };

  if (!document.getElementById('react-addtocart-popup-styles')) {
    var styleSheet = document.createElement('style');
    styleSheet.id = 'react-addtocart-popup-styles';
    styleSheet.textContent =
      '@keyframes fadeInZoom { 0% { opacity: 0; transform: scale(0.95); } 100% { opacity: 1; transform: scale(1); } }' +
      '.react-addtocart-popup-content { font-family: D-DIN, sans-serif; }' +
      '@media (max-width: 1024px) { .react-addtocart-popup-content { max-width: 90% !important; padding: 56px 40px !important; } .react-addtocart-popup-content svg { width: 90px !important; height: 90px !important; } .react-addtocart-popup-content h2 { font-size: 18px !important; } }' +
      '@media (max-width: 767px) { .react-addtocart-popup-content { max-width: 85% !important; padding: 48px 32px !important; border-radius: 20px !important; } .react-addtocart-popup-content svg { width: 80px !important; height: 80px !important; } .react-addtocart-popup-content h2 { font-size: 16px !important; letter-spacing: 0.08em !important; } }' +
      '@media (max-width: 480px) { .react-addtocart-popup-content { max-width: 90% !important; padding: 40px 24px !important; border-radius: 16px !important; } .react-addtocart-popup-content svg { width: 70px !important; height: 70px !important; } .react-addtocart-popup-content h2 { font-size: 14px !important; letter-spacing: 0.05em !important; } }';
    document.head.appendChild(styleSheet);
  }
})();
